import { Typography } from "@mui/material";

interface PageTitleProps {
  title: string;
}

function PageTitle({ title }: PageTitleProps) {
  return (
    <Typography variant="h5" gutterBottom fontWeight="bold" margin="15px">
      {title}
    </Typography>
  );
}

export default PageTitle;
